import { getPreviousDate } from "../components/utils/dateFormate";
import apiService from "./api";

export const userTypeService = async (domainName,date=getPreviousDate(), limit=5,page=1, isRegistered=false,token) => {
    const url = `/api/v1/admin/get-users-engagement?domain=${domainName}&limit=${limit}&pageNo=${page}&startDate=${date}&isRegistered=${isRegistered}`;
    
    try {
        const response = await apiService.get(url, {}, token);
        console.log('resp', response.data);
        
        return response.data

    } catch (error) {
        console.log('resp',error);
        throw error;
    }
}